<template>
  <b-container>

    <b-modal
      @ok="handleOk"
      id="confirm-password"
      ok-variant="success"
      title="Confirm your password to proceed.">
      <b-form-group label="Enter your current password:">
        <b-form-input type="password" autofocus v-model="password">
        </b-form-input>
      </b-form-group>
      <b-alert
        dismissible
        style="width: 100%"
        v-model="wrongPasswordAlert"
        variant="danger">
        Wrong password. Please try again.
      </b-alert>
    </b-modal>

    <div class="pb-lg-5 pt-lg-5">
      <b-row>
        <div class="col-lg-3 col-md-3 col-sm-2"></div>
        <div class="col-lg-6 col-md-6 col-sm-8 col-xs-12">
          <h2 class="text-center mb-3">Edit your account</h2>

          <b-form @submit.prevent="confirmExistingPassword">
            <b-form-group class="text-left" label="First Name">
              <b-form-input
                class="form-control form-control-sm validate"
                id="id_name"
                placeholder="Enter your first name"
                required
                type="text"
                v-model="form.name">
              </b-form-input>
            </b-form-group>

            <b-form-group class="text-left" label="Surname">
              <b-form-input
                class="form-control form-control-sm validate"
                id="id_surname"
                placeholder="Enter your surname"
                type="text"
                v-model="form.surname">
              </b-form-input>
            </b-form-group>

            <b-form-group class="text-left" label="Username">
              <b-form-input
                class="form-control form-control-sm validate"
                disabled
                id="id_username"
                placeholder="Enter your username"
                required
                type="text"
                v-model="form.login">
              </b-form-input>
            </b-form-group>

            <b-form-group class="text-left" label="Email">
              <b-form-input
                class="form-control form-control-sm validate"
                id="id_email"
                placeholder="Enter your email"
                required
                type="text"
                v-model="form.email">
              </b-form-input>
            </b-form-group>

            <b-form-group class="text-left" label="New password" v-show="checkMatch">
              <b-form-input
                autocomplete="new-password"
                class="form-control form-control-sm validate"
                id="id_password"
                placeholder="Enter a new password"
                type="password"
                v-model="form.password">
              </b-form-input>
            </b-form-group>

            <b-form-group class="text-left" label="Repeat new password" v-show="checkMatch">
              <b-form-input
                autocomplete="new-password"
                class="form-control form-control-sm validate"
                id="id_repeat_password"
                placeholder="Repeat your new password"
                type="password"
                v-model="form.repeatPassword">
              </b-form-input>
            </b-form-group>

            <b-form-group class="text-left" label="New password" v-show="!checkMatch">
              <b-form-input
                autocomplete="new-password"
                class="form-control form-control-sm validate"
                id="id_password"
                placeholder="Enter a new password"
                type="password"
                v-model="form.password">
              </b-form-input>
            </b-form-group>

            <b-form-group class="text-left" label="Repeat new password" v-show="!checkMatch">
              <b-form-input
                autocomplete="new-password"
                class="form-control form-control-sm validate"
                id="id_repeat_password"
                placeholder="Repeat your new password"
                type="password"
                v-model="form.repeatPassword">
              </b-form-input>
            </b-form-group>

            <b-button class="btn btn-block" type="submit" variant="info">Save</b-button>
          </b-form>
          <div class="mt-lg-5 text-center">
            <router-link :to="{name: 'home'}" class="text-info">Home page</router-link>
            &bullet;
            Already have an account?
            <router-link :to="{name: 'login'}" class="text-info">Login</router-link>
          </div>
        </div>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import axios from 'axios'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

export default {
  name: 'editUser',
  beforeCreate () {
    this.$store.dispatch('getUser')
    // Firstly, get the current user (cannot apply $route.params.id because the id does not exist on the router link)
      .then(response => {
        // Having the user id, fetch the needed data
        return axios.get('/user/' + response.id, {withCredentials: true})
          .then(user => {
            this.form = user.data
          })
      })
  },
  components: {
    Navbar,
    Footer
  },
  data () {
    return {
      wrongPasswordAlert: false,
      password: '',
      checkMatch: true,
      form: {
        name: '',
        surname: '',
        login: '',
        email: '',
        password: '',
        repeatPassword: ''
      }
    }
  },
  methods: {
    handleOk (bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.checkPassword()
    },
    checkPassword (event) {
      let credentials = {
        login: this.form.login,
        password: this.password
      }
      console.log(credentials)
      this.$store.dispatch('checkPassword', credentials)
        .then(reply => {
          console.log(reply)
          if (reply.status === 200) {
            this.editUser()
            // this.$router.push({name: 'home'})
            // console.log('success')
          } else {
          }
        }).catch((error) => {
          this.wrongPasswordAlert = true
          console.info(error)
          // this.showMsgFail()
        })
    },
    confirmExistingPassword () {
      if (this.form.password === this.form.repeatPassword) {
        this.$bvModal.show('confirm-password')
      } else {
        this.showMsgNoMatch()
        this.checkMatch = false
      }
    },
    showMsgSuccess () {
      this.boxOne = ''
      this.$bvModal.msgBoxOk('Your info have been successfully changed.', {
        okVariant: 'success'
      })
        .then(value => {
          this.boxOne = value
          if (this.boxOne) {
            this.$router.push({name: 'account'})
          } else {
          }
        })
        // .catch(error => {
        //   alert('An error occurred! Please refresh the page.' + error)
        // })
    },
    showMsgFail () {
      this.boxOne = ''
      this.$bvModal.msgBoxOk('Something went wrong. Please try again.', {
        okVariant: 'danger'
      })
        .then(value => {
          this.boxOne = value
          if (this.boxOne) {
            window.location.reload()
          } else {
          }
        })
        .catch(error => {
          alert('An error occurred! Please refresh the page.' + error)
        })
    },
    showMsgNoMatch () {
      this.boxOne = ''
      this.$bvModal.msgBoxOk('The passwords do not match. Please try again.', {
        okVariant: 'danger'
      })
        .then(value => {
          this.boxOne = value
          if (this.boxOne) {
            this.form.password = ''
            this.form.repeatPassword = ''
          } else {
          }
        })
        .catch(error => {
          alert('An error occurred! Please refresh the page.' + error)
        })
    },
    editUser (event) {
      let profile = {
        login: this.form.login,
        name: this.form.name,
        surname: this.form.surname,
        email: this.form.email,
        password: this.password
        // repeatPassword: this.form.repeatPassword // it is supported from the api
      }

      if (this.form.password) {
        profile.password = this.form.password
      }

      // if (this.form.password === this.form.repeatPassword) {
      axios.post('/user/' + this.form.id, profile, {withCredentials: true}, {headers: {'Content-Type': 'application/json'}})
        .then(response => {
          console.log(response)
          if (response.status === 200) {
            this.showMsgSuccess()
          } else {
          }
        })
        .catch((error) => {
          console.info(error)
          this.showMsgFail()
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/AccountEdit.vue